import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useResetPassword = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: mutateAsyncResetPassword } = useMutation('resetAffiliatePassword', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['affiliates'] });
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsyncResetPassword };
};

export default useResetPassword;
